import {Component} from 'substance'

/**
 * @typedef UIInlineImage.props
 * @property {string} nodeId - The file/image nodeId which implements getUrl-method
 */

/**
 * Inline image component which rerenders itself when its FileNode is loaded.
 *
 * @name UIInlineImage
 * @class
 *
 * @example
 * import {UIInlineImage} from 'writer'
 *
 * render($$) {
 *     const el = $$('div')
 *     return el.append($$(UIInlineImage, {
 *         nodeId: imageFileNodeId
 *     }))
 * }
 *
 * @param {UIInlineImage.props} props
 * @property {UIInlineImage.props} props
 */
class InlineImageComponent extends Component {

    didMount() {
        this.context.editorSession.onRender('document', this._onDocumentChange, this)
    }

    _onDocumentChange(change) {
        if (change.isAffected(this.props.nodeId)) {
            this.rerender()
        }
    }

    render($$) {
        const imageNode = this.context.doc.get(this.props.nodeId)
        return $$('img', {
            src: imageNode.getUrl()
        }).addClass('im-inline-image')
    }

}

export {InlineImageComponent}
